import React from 'react'
import { Box } from '@mantine/core'
import SlopFeed from '../../components/SlopFeed'
import SlopFeedPageHeader from './SlopFeedPageHeader'
import SlopSecondaryNav from './SlopSecondaryNav'
import { slopFeedPageShellSx } from './slopFeedLayout'

/** Default Slop landing: mixed Discover feed (shoots + slop posts + blog). */
export default function SlopFeedPage () {
  return (
    <Box sx={slopFeedPageShellSx}>
      <SlopSecondaryNav mode="discover" />
      <SlopFeedPageHeader variant="discover" />
      <SlopFeed />
    </Box>
  )
}
